<nav #header class="fixed-top backg"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerMenu navbar-collapse collapse">
        <div>
            <a href="https://luxuryprivatejourneys.com/" target="_blank">
                <img class="logo" src="../assets/images/logos-header/lpj.svg" />
            </a>
        </div>
        <div style="display: flex;align-items: center;">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
        </div>

    </div>
    <div #header1 class="containerHeader" [ngClass]="showMenu ? 'showMenu':''" style="border-top: 1px solid #9AC40E;">
        <ul class="navbar-nav">
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/" target="_blank">Home</a>
            </li>
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/destinations/ecuador-luxury/" target="_blank">Destination<i
                        class="fa fa-angle-down" style="padding-left: 5px;"></i></a>
            </li>
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/travel-styles/boutique-travel/" target="_blank">Travel Style<i
                        class="fa fa-angle-down" style="padding-left: 5px;"></i></a></li>
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/blog-lpj/"
                    target="_blank">Inspiration<i class="fa fa-angle-down" style="padding-left: 5px;"></i></a></li>
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/who-we-are-lpj/"
                    target="_blank">Why us<i class="fa fa-angle-down" style="padding-left: 5px;"></i></a></li>
            <li class="nav-item menuItem last"><a href="https://luxuryprivatejourneys.com/luxury-properties/ecuador-property/"
                    target="_blank">Where to stay<i class="fa fa-angle-down" style="padding-left: 5px;"></i></a>
            </li>
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/contact-page-lpj/" target="_blank">Contact us</a>
            </li>
        </ul>
        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
            <app-heart-header></app-heart-header>
        </div>
    </div>
</nav>